<script lang="ts" setup>
  import { computed } from 'vue'

  import { useLocalStorage } from '@vueuse/core'
  import { useI18n } from 'vue-i18n'
  import FlagDe from '@/elements/flags/flag-de.vue'
  import FlagGb from '@/elements/flags/flag-gb.vue'

  const { locale } = useI18n({ useScope: 'global' })
  const browserLocale = useLocalStorage<string | undefined>('locale', undefined)
  const activeLocale = computed<string>({
    get: () => {
      return locale.value
    },
    set: (v) => {
      locale.value = v
      browserLocale.value = v
    }
  })
</script>

<template>
  <div class="flex gap-x-4">
    <flag-de
      :class="{ 'ring-4 rounded ring-perl-400': locale == 'de', 'cursor-pointer rounded hover:ring-4 hover:ring-indigo-500 titrop-focus': true }"
      size="5"
      @click="activeLocale = 'de'" />
    <flag-gb
      :class="{ 'ring-4 ring-perl-400': locale == 'en', 'cursor-pointer rounded hover:ring-4 hover:ring-indigo-500 shadow titrop-focus': true }"
      size="5"
      @click="activeLocale = 'en'" />
    <!--        <flag-ru-->
    <!--            :class="{'ring-4 rounded ring-perl-400':locale=='ru','cursor-pointer rounded hover:ring-4 hover:ring-indigo-500 shadow-2xl	':true}"-->
    <!--            size="5"-->
    <!--            @click="activeLocale='ru'" />-->
  </div>
</template>

<style scoped></style>
<i18n>
{
  "de": {
    "name": "deutsch"
  },
  "en": {
    "name": "english"
  }
}
</i18n>
